/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Manager_Boiler_RoomInputs */



/**
* | output |
* | --- |
* | "Manager +" |
*
* @param {Manager_Boiler_RoomInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const manager_boiler_room = /** @type {((inputs?: Manager_Boiler_RoomInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Manager_Boiler_RoomInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Manager +")
	return /** @type {LocalizedString} */ ("Gestionnaire +")
});